//export const httpURL = `https://oa.tianjiare.com/`
//export const httpImgURL = `https://oa.tianjiare.com`
export const httpURL = `http://42.51.227.170/`
export const httpImgURL = `http://42.51.227.170`
// 编辑器图片上传接口
export const editorUploadURL = `/v1/html/editor/upload`
// 登录
export const loginURL = `/v1/user/authentication`
// 修改密码
export const passwordURL = `/v1/user/password`
// 查询所有用户
export const allUserURL = `/v1/archives/users`
// 消息管理
export const messageListURL = `/v1/message/list`
// 来确认消息路径是否有效 true:有效 false:失效 /v1/message/{messageId}/url/validate
export const ifMessageURL = `/v1/message/`

// 人力资源
// 1.奖惩管理
export const punishmentsListURL = `/v1/rewards/punishments/list`
// 添加 删除 修改 查看
export const punishmentsURL = `/v1/rewards/punishments/`

// 2。离职管理
export const recorderListURL = `/v1/leave/record/list`
// 添加 删除 修改 查看
export const recorderURL = `/v1/leave/record/`

// 3。员工关怀管理
export const careListURL = `/v1/care/list`
// 添加 删除 修改 查看
export const careURL = `/v1/care/`

// 4。人事档案管理
export const archivesListURL = `/v1/archives/list`
// 添加 删除 修改 查看人事档案
export const archivesURL = `/v1/archives/`

// 5.合同信息管理
export const contractListURL = `/v1/contract/list`
// 添加 删除 修改 查看
export const contractURL = `/v1/contract/`

// 6.合同操作记录管理
export const contractRecordListURL = `/v1/contract/operate/record/list`
// 添加 删除 修改 查看
export const contractRecordURL = `/v1/contract/operate/record/`

// 7.证照类型管理
export const licenseTypeListURL = `/v1/license/type/list`
// 添加 删除 修改 查看
export const licenseTypeURL = `/v1/license/type/`

// 8.证照信息管理
export const licenseListURL = `/v1/license/list`
// 添加 删除 修改 查看
export const licenseURL = `/v1/license/`

// 9.学习经历管理
export const educationListURL = `/v1/education/experience/list`
// 添加 删除 修改 查看
export const educationURL = `/v1/education/experience/`

// 10.工作经历管理
export const workListURL = `/v1/work/experience/list`
// 添加 删除 修改 查看
export const workURL = `/v1/work/experience/`

// 11.社会关系管理
export const socialListURL = `/v1/social/relation/list`
// 添加 删除 修改 查看
export const socialURL = `/v1/social/relation/`

// 12.查看职称评定列表
export const assessmentListURL = `/v1/job/title/assessment/list`
// 查看
export const assessmentURL = `/v1/job/title/assessment/`

// 13.培训计划
export const trainingPlanListURL = `/v1/training/plan/record/list`
//  添加 删除 修改 查看
export const trainingPlanURL = `/v1/training/plan/record/`

// 14.培训记录
export const trainingListURL = `/v1/training/record/list`
//  添加 删除 修改 查看
export const trainingURL = `/v1/training/record/`

// 15.招聘管理
export const recruitmentPlanListURL = `/v1/recruitment/plan/record/list`
// 招聘需求列表
export const recruitmentDemandListURL = `/v1/recruitment/demand/list`
//  添加 删除 修改 查看
export const recruitmentPlanURL = `/v1/recruitment/plan/record/`

// 16.考核管理
// 查看培考核指标集列表
export const assessSetListURL = `/v1/assess/indicator/set/list`
//  添加 删除 修改 查看
export const assessSetURL = `/v1/assess/indicator/set/`
// 查看考核任务管理列表
export const assessListURL = ` /v1/assess/indicator/list`
//  添加 删除 修改 查看
export const assessURL = `/v1/assess/indicator/`

// 17.积分管理
// 积分项分类列表
export const integralTypeListURL = `/v1/integral/items/type/list`
//  添加 删除 修改 查看
export const integralTypeURL = `/v1/integral/items/type/`

// 积分项列表
export const integralItemsListURL = `/v1/integral/items/list`
//  添加 删除 修改 查看
export const integralItemsURL = `/v1/integral/items/`

// 积分表
export const integralListURL = `/v1/integral/list`
//  添加 删除 修改 查看
export const integralURL = `/v1/integral/`

// 根据主分类查询积分项
export const integralByURL = `/v1/integral/items/list/by`

// 查询所有积分主分类
export const integralTypeByURL = `/v1/integral/items/type/list/by`

// 案卷管理
// 1 获取，修改，删除，新增案件标题详情    get
export const dossierTitleURL = `/v1/dossier/title/`
// 2.获取列表页数据
export const dossierTitleListURL = `/v1/dossier/title/list`
// 3.添加,修改 删除案卷信息
export const dossierURL = `/v1/dossier/`
// 案卷导出 get
export const dossierExportURL = `/v1/dossier/export`
// 案卷导入 post
export const dossierImportURL = `/v1/dossier/import`

// 文件管理
// 1文件列表
export const fileListURL = `/v1/file/cabinet/allList`
// 2文件上传  /api
export const fileUploadURL = `/v1/file/cabinet/upload`
// 3删除文件
export const fileDeleteURL = `/v1/file/cabinet/delete`
// 4下载文件
export const fileDownloadURL = `/v1/file/cabinet/download`
// 5新建文件夹
export const fileMkdirURL = `/v1/file/cabinet/mkdir`
// 6重命名
export const fileRenameURL = `/v1/file/cabinet/rename`
// 7移动文件
export const fileMoveURL = `/v1/file/cabinet/move`

// 文件柜设置
// 1查询文件柜所有信息
export const filefindAllURL = `/v1/file/cabinet/options/findAll`
// 2文件柜设置大小
export const saveOrUpdateSizeURL = `/v1/file/cabinet/options/saveOrUpdateSize`
// 3磁盘使用情况
export const diskUsageURL = `v1/file/cabinet/options/diskUsage`

// 个人事务
// 1.个人事务-工作日志
export const workLogListURL = `/v1/work/log/list`
// 2日志添加 删除 修改 查看
export const workLogURL = `/v1/work/log/`

// 日程管理
// 1.个人事务-日程管理
export const scheduleListURL = `/v1/schedule/list`
export const schedulePeriodAllURL = `/v1/schedule/period/all`
// 2日程添加 删除 修改 查看
export const scheduleActionURL = `/v1/schedule/`
export const scheduleSaveURL = `/v1/schedule`

// 邮箱管理
// 1.保存草稿
export const saveDraftURL = `/v1/email/saveDraft`
// 2.发送邮件
export const sendEmailURL = `/v1/email/send`
// 3.回复收件信息
export const replyEmaiURL = `/v1/email/replyEmail`
// 4.转发收件信息
export const forwardEmailURL = `/v1/email/forwardEmail`
// 5.查看 草稿/已发送 全部信息
export const lookEmailListURL = `/v1/email/lookEmail`
//6.查看收件箱  全部信息
export const lookReceiveEmailListURL = `/v1/email/lookReceiveEmail`
// 7查看 草稿/已发送/收件箱 单个
export const lookEmailByIdURL = `/v1/email/lookEmailById/`
// 查看 草稿 单个
export const lookDraftURL = `/v1/email/draft/`
// 8.查看回收站  全部信息
export const lookRecycleListURL = `/v1/email/lookRecycle`
// 9查看回收站 单个
export const lookRecycleByIdURL = `/v1/email/lookRecycleById/`

// 10删除（放入回收站）
export const deleteEmailURL = `/v1/email/deleteEmail`
// 11.彻底删除
export const deleteRecycleEmailURL = `/v1/email/deleteRecycleEmail`
// 12.统计邮件数量
export const totalCountURL = `v1/email/totalCount`
// 13.查询未读邮件
export const unReadEmailsURL = `v1/email/unReadEmails`

// 行政办公
// 新闻管理
// 1.新闻列表
export const newsListURL = `/v1/news/list`
// 2.新闻单个操作(u)(i)
export const newsActionURL = `/v1/news/`
// 3.新闻添加
export const newsAddURL = `/v1/news`
// 公告管理
// 1.公告列表
// export const noticeListURL = `/v1/notice/findAll`
export const noticeListURL = `/v1/notice/list`
// 2.公告查询单个
// export const noticeDetailURL = `/v1/notice/getById/`
export const noticeActionURL = `/v1/notice/`
// 3.公告添加
export const noticeAddURL = `/v1/notice`
// 4.公告修改
// export const noticeUpdateURL = `/v1/notice/update`
// 5.公告删除
// export const noticeDeleteURL = `/v1/notice/delete`
// 6.改变公告状态
// export const noticeUpdateStateURL = `v1/notice/updateState`
// 7.查看阅读人及阅读次数
export const noticeReadersURL = `/v1/notice/readers/`
// 工作计划
// 1.工作计划列表
export const planListURL = `/v1/work/plan/list` // 没改完
// 2.添加工作计划
export const planAddURL = `/v1/work/plan`

export const planActionURL = `/v1/work/plan/`
// 3.修改工作计划
// export const planUpdateURL = `/v1/work/plan/update/`
// 4.删除工作计划
// export const planDeleteURL = `/v1/work/plan/delete/`
// .查询单个工作计划
// export const planGetURL = `/v1/work/plan/`

// 5.工作计划类型列表
export const planTypeListURL = `/v1/work/plan/type/list`
export const planTypeAllURL = `/v1/work/plan/type/all`
// 6添加.工作计划类型
export const planTypeAddURL = `/v1/work/plan/type`
// 7修改.工作计划类型
// export const planTypeUpdateURL = `/v1/work/plan/type/update/`
// 8.删除工作计划类型
// export const planTypeDeleteURL = `/v1/work/plan/type/delete/`
export const planTypeActionURL = `/v1/work/plan/type/`

// 9.添加反馈
export const feedBackSaveURL = `/v1/work/plan/feedback`
// 10.添加反馈
export const feedBackListURL = `/v1/work/plan/{planId}/feedback/all`

// 行政办公-会议室模块
// 1会议室列表
export const meetRoomListURL = `/v1/meeting/room/list`
// 2添加会议室
export const meetRoomSaveURL = `/v1/meeting/room`
export const meetRoomActionUrl = `/v1/meeting/room/`
export const meetRoomIdAndNameListURL = `/v1/meeting/room/id-and-name/all`
// 3修改会议室
// export const meetRoomUpdateURL = `/v1/meeting/room/update`
// 4删除会议室
// export const meetRoomDelURL = `/v1/meeting/room/delete`
// 5查询全部会议室设备+模糊查询
export const meetDeviceListURL = `/v1/meeting/room/device/list`
// 6添加会议室设备
export const meetDeviceSaveURL = `/v1/meeting/room/device/`
export const meetDeviceActionURL = `/v1/meeting/room/device/`
// 7修改会议室设备
// export const meetDeviceUpdateURL = `/v1/meeting/room/device/update`
// 8删除会议室设备
// export const meetDeviceDelURL = `/v1/meeting/room/device/delete`
// 9查询全部会议室使用情况+模糊查询
export const meetRoomUseListURL = `/v1/meeting/room/use/plan/list`
// 10查询全部会议室
export const meetRoomAllURL = `v1/meeting/room/id-and-name/all`

// 九、行政办公-车辆管理
// (u)
// 1查询全部车辆类型+模糊查询
export const carTypeListURL = `/v1/car/type/list`
// 2添加车辆类型
export const carTypeSaveURL = `/v1/car/type`
// 3.车辆类型操作 对数据有破坏性的操作(删除、修改)、查看详情
export const carTypeActionURL = `/v1/car/type/`
// 4.获取所有车辆类型
export const carTypeAllURL = `/v1/car/type/all`
// 5.获取所有车牌号
export const carNumberURL = `v1/car/id-and-plate-number/all`

// (u)
// 5查询全部车辆+模糊查询
export const carListURL = `/v1/car/list`
// 6添加车辆
export const carSaveURL = `/v1/car`
// 7车辆信息操作 对数据有破坏性的操作(删除、修改)、查看详情
export const carActionURL = `/v1/car/`


// 9查询全部车辆使用记录+模糊查询
export const carUseRecordListURL = `/v1/car/use/record/list`
// 10根据ID查询车辆使用记录 get
export const carUseRecordGetURL = `/v1/car/use/record/`
// 11查询全部车辆维护记录+模糊查询
export const carMtRecordListURL = `/v1/car/maintenance/record/list`
// 12根据ID查询车辆维护记录
export const carMtRecordGetURL = `/v1/car/maintenance/record/`

// 行政办公-办公用品
// 1查询全部办公用品库+模糊查询
export const officeSlListURL = `/v1/office/supplies/library/list`
// 2添加办公用品库
export const officeSlSaveURL = `/v1/office/supplies/library`
//
export const officeSlActionURL = `/v1/office/supplies/library/`
// 所有办公用品库
export const officeSlAllURL = `/v1/office/supplies/library/all`
// 3修改办公用品库
// export const officeSlUpdateURL = `/v1/office/supplies/library/update`
// 4删除办公用品库
// export const officeSlDelURL = `/v1/office/supplies/library/delete`
// 5查询全部办公用品类型+模糊查询
export const officeTypeListURL = `/v1/office/supplies/type/list`
export const officeTypeAllURL = `/v1/office/supplies/type/all`
// 6添加办公用品类型
export const officeTypeSaveURL = `/v1/office/supplies/type`
export const officeTypeActionURL = `/v1/office/supplies/type/`
// 7修改办公用品类型
// export const officeTypeUpdateURL = `/v1/office/supplies/type/update`
// 8删除办公用品类型
// export const officeTypeDelURL = `/v1/office/supplies/type/delete`
// 9查询全部办公用品信息+模糊查询
export const officeInfoListURL = `/v1/office/supplies/info/list`
//10添加办公用品信息
export const officeInfoSaveURL = `/v1/office/supplies/info`

export const officeInfoActionURL = `/v1/office/supplies/info/`
// 11修改办公用品信息
// export const officeInfoUpdateURL = `/v1/office/supplies/info/update`
// 12删除办公用品信息
// export const officeInfoDelURL = `/v1/office/supplies/info/`
// 13查询全部办公用品库存操作记录+模糊查询
export const officeRecordListURL = `/v1/office/supplies/inventory/record/list`
// 14添加办公用品库存操作记录
export const officeRecordSaveURL = `/v1/office/supplies/inventory/record`
// 14添加办公用品库存操作记录
export const officeAllURL = `v1/office/supplies/info/id-and-name/all`

// 行政办公-投票管理
// 1查询全部办公用品库+模糊查询
export const voteListURL = `/v1/vote/list`
// 2添加投票
export const voteSaveURL = `/v1/vote`

export const voteActionURL = `/v1/vote/`
// 3修改投票
// export const voteUpdateURL = `/v1/vote/update`
// 4删除投票
// export const voteDelURL = `/v1/vote/delete`
// 5投票
// export const voteRecordURL = `/v1/vote/record/save`  // 没改完
export const voteRecordURL = `/v1/vote/record`
// 6.查看投票结果
// export const voteResultURL = `/v1/vote/record/`
// 7.查看投票人
export const getVoteManURL = `/v1/vote/record/voter`
// 8.查看投票详情
// export const VoteGetURL = `/v1/vote/`

// 部门管理
// 1.所有部门
export const deptListURL = `/v1/dept/children-with-users`
// 2.部门修改，删除，查询,添加
export const deptURL = `/v1/dept/`
// 1.角色列表
export const roleListURL = `/v1/role/all`
// export const roleListURL = `/v1/role/list`
// 2.角色修改，删除，查询,添加
export const roleURL = `/v1/role/`
// 1.用户列表
export const userListURL = `/v1/user/list`
// 2.用户修改，删除，查询,添加
export const userURL = `/v1/user/`
// 3.获取全部人员
export const userAllURL = `/v1/user/all`
// 4.获取部门
export const deptAllURL = `/v1/dept/all`

// 交流园地
// 1主贴列表
export const discussListURL = `/v1/discuss/list`
// 2发布主贴,修改主贴，删除主贴
export const discussURL = `/v1/discuss/`
// 3根据主贴ID获取评论列表(分页) /v1/discuss/2/comments
export const discussCommentsURL = `/v1/discuss/`
// 4发布 删除评论 根据评论ID获取对话列表
export const commentURL = `/v1/discuss/comment/`

// 历史任务实例管理
// 1.查看历史任务详情
export const historyTaskURL = `/v1/history/historic-task-instance/`
//2.查看历史任务列表
export const historyListURL = `/v1/history/historic-task-instance/list`

// 历史流程实例管理
// 1.根据历史流程实例ID获取详情
export const historyProcessURL = `/v1/history/historic-process-instances/`
//2.获取历史流程分页列表(我发起的/我抄送的/分享给我的)
export const historyProcessListURL = `/v1/history/historic-process-instances`

// 考勤-考勤组
// 1查询考勤组列表
export const attendanceListURL = `/v1/attendance/group/list`
// 2.添加,修改，查询数据
export const attendanceURL = `/v1/attendance/group/`
// 3.修改考勤组状态
export const attendanceStateURL = `/v1/attendance/group/status`

// 二、考勤记录
// 1查询全部考勤记录+模糊查询
export const attendanceRecordListAllURL = `/v1/attendance/record/listAll`
// 2..查询个人考勤记录+模糊查询
export const attendanceRecordListURL = `/v1/attendance/record/list`

// 三、考勤统计
// 1所用用户考勤统计
export const attendanceSticsListURL = `/v1/attendance/statistics/list`
//2个人考勤统计
export const attendanceSticsGetoneURL = `/v1/attendance/statistics/mine/list`
//考勤数据导出
export const attendanceExportURL = `/v1/attendance/statistics/export`

// 模型管理
// 1.查找所有模型
export const modelGroupURL = `/v1/repository/model/group`
// 2.新建分组 修改 删除
export const addModelGroupURL = `/v1/model/process/category/`
// 3.查看所有分组
export const allModelGroupURL = `/v1/model/process/category/all`
// 4.获取模型详情 // 删除单个审批流程
export const modelDeatilURL = `/v1/repository/model/`
// 可見人
export const modelCanOpenerURL = `/v1/repository/model/{modelId}/opener/related`

// 表单管理模块
// 1.根据ID获取,新增，修改
export const formTemplateURL = `/v1/form/template/`
// 流程部署
export const processDefinitionURL = `/v1/repository/process-definition`
// 开启流程模块
export const processGroupURL = `/v1/repository/process-definition/group`

// 系统管理
// 定时任务模块列表
export const systemJobListURL = `/v1/system/job/list`
// 操作与暂停、恢复、修改
export const systemJobURL = `/v1/system/job/`
// 系统日志
export const systemListURL = `/v1/system/log/list`
export const systemModulesListURL = `/v1/system/log/modules/list`
export const systemActionListURL = `/v1/system/log/action/list`
// 短信通知用户列表
export const smsNoticeListURL = `/v1/user/sms/notice/list`
// 添加短信通知用户
export const smsNoticeURL = `/v1/user/sms/notice`

// 获取全部资源
export const resourceTreeURL = `/v1/resource/tree/data`
// 获取，设置 角色可操作资源
export const rolePermissionURL = `/v1/role/`
// 获取申请表单
export const runtimeTaskURL = `/v1/runtime/tasks/`

// 待办事宜列表
export const runtimeTaskListURL = `/v1/runtime/tasks`
// 已办事宜列表
export const historicTaskListURL = `/v1/history/historic-task-instance/list`
// 查看已办事宜
export const historicTaskURL = `/v1/history/historic-task-instance/`
//开启,撤销，删除流程
export const runtimeProcessURL = `/v1/runtime/process-instances/`
//历史流程 我发起的/我抄送的/分享给我的)
export const historicProcessURL = `/v1/history/historic-process-instances/`
// 查找审批类型
export const idNameURL = `v1/repository/process-definition/id-and-name/list`
// 申请流程 删除附件,
export const taskAttachmentURL = `v1/runtime/tasks/attachment/`
// 下载附件
export const attachmentDownURL = `v1/attachment/`
// 打印流程
export const printURL = `/v1/history/historic-process-instances/`


// 请假规则
// 1新增请假,修改，删除规则
export const holidayRuleURL = `/v1/holiday/rule/`
// 2.查询所有请假规则
export const holidayRuleAllURL = `/v1/holiday/rule/all`
// 3.获取所有能导出的请假规则
export const holidayRuleExportListURL = `/v1/holiday/rule/enable/export/type/list`
// 4.获取员工各种假期规则的剩余天数(分页列表)
export const holidayUserDayListURL = `/v1/holiday/user/days/list`
// 5修改员工指定规则下的剩余天数 查询员工请假天数汇总信息
export const holidayUserDayURL = `/v1/holiday/user/`
// 6员工请假天数导出
export const holidayUserDayExportURL = `v1/holiday/user/days/export`
//7 员工请假天数导入
export const holidayUserDayImportURL = `/v1/holiday/user/days/import`

//8获取所有请假类型
export const holidayNameAllURL = `/v1/holiday/rule/id-and-name/all`
// 文件预览 v1/attachment/{attachmentId}/preview
export const attachmentPreviewURL = `/v1/attachment/`

// 1.发送紧急通知
export const sendEmergencyNoticeURL = `/v1/emergency/notice`
// 获取信息详情
export const messageURL = `/v1/message/`
// 4.获取未读数量
export const messageUnreadCountURL = `/v1/message/unread/count`
// 导出人事档案数据
// 获取可导出字段
export const archivesExportFieldURL = `/v1/archives/export/field`
// 导出
export const archivesExportURL = `/v1/archives/export`
// 导入
export const archivesImportURL = `/v1/archives/import`

// 创建招聘计划
export const planProcessesURL = `/v1/plan/processes`
export const planProcessURL = `/v1/plan/process`

// 申请流程上传附件
export const runtimeTaskUploadURL = `/v1/runtime/tasks/`
// 投票结果通知投票人v1/vote/{id}/result/prompt
export const voteResultURL = `/v1/vote/`

// 获取会议室使用情况v1/meeting/room/{roomId}/book/record
export const applyMeetRoomRecordURL = `/v1/meeting/room/`
// 获取车辆使用情况v1/car/{carId}/book/record
export const applyCarRecordURL = `/v1/car/`
// 流程评论功能
export const processCommentURL = `/v1/history/historic-process-instances/comment/`


export const getClickviewlogAllURL = `/v1/clickviewlog/all`
export const addClickviewlogURL = `/v1/clickviewlog`



// WEBPACK FOOTER //
// ./src/api/http.js